export default __webpack_public_path__ + "static/media/logo_mang.0101fe6e.svg";